import { render } from "./OptionSize.vue?vue&type=template&id=e5a2b728&scoped=true"
import script from "./OptionSize.vue?vue&type=script&lang=js"
export * from "./OptionSize.vue?vue&type=script&lang=js"

import "./OptionSize.vue?vue&type=style&index=0&id=e5a2b728&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5a2b728"]])

export default __exports__